<div class="toast-container">
  <ng-container *ngFor="let toast of toasts | async; trackBy: trackBy">
    <ng-container *ngIf="toast.type && toast.type !== 'basic'">
      <ng-container
        *ngTemplateOutlet="toastTemplate; context: { toast: toast }"
      ></ng-container>
    </ng-container>
  </ng-container>
</div>

<div class="toast-container bottom">
  <ng-container *ngFor="let toast of toasts | async; trackBy: trackBy">
    <ng-container *ngIf="!toast.type || toast.type === 'basic'">
      <ng-container
        *ngTemplateOutlet="toastTemplate; context: { toast: toast }"
      ></ng-container>
    </ng-container>
  </ng-container>
</div>

<ng-template #toastTemplate let-toast="toast">
  <div class="wrapper" [class.leave]="toast.leave">
    <ng-container *ngIf="toast.template">
      <ng-container *ngTemplateOutlet="toast.template"></ng-container>
    </ng-container>
    <ng-container *ngIf="!toast.template && toast.message">
      <toast [icon]="toast.icon" [type]="toast.type">
        {{ toast.message }}
      </toast>
    </ng-container>
  </div>
</ng-template>
